import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";

// Определяем новогодний сезон
const isNewYearSeason = () => {
  const todayMD = dayjs().format("MM-DD");
  // Даты новогоднего логотипа
  const start = "12-01";
  const end = "01-31";

  return todayMD >= start || todayMD <= end;
};

export function Logo() {
  return isNewYearSeason() ? LogoSvgNY() : LogoSvgNormal();
}

export function LogoSvgNormal() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="117.591"
      height="42"
      viewBox="0 0 117.591 42"
    >
      <defs>
        <filter
          id="a"
          x="0"
          y="0"
          width="117.591"
          height="42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" in="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="b" />
          <feFlood floodOpacity="0.078" />
          <feComposite operator="in" in2="b" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#a)">
        <path
          d="M.729,0V-.978l2.258-.587A1.248,1.248,0,0,0,3.6-1.947a.913.913,0,0,0,.222-.667V-21.884a.95.95,0,0,0-.231-.693,1.162,1.162,0,0,0-.6-.373L.729-23.52V-24.5H11.36v.978l-2.382.569a1.224,1.224,0,0,0-.6.391,1.014,1.014,0,0,0-.24.676v20.16h8.711a.553.553,0,0,0,.524-.347,3.777,3.777,0,0,0,.24-.6L19.076-7.36H20.16L20.178,0Zm21.4,0V-2.133q2.6-1.973,4.524-3.387a37.1,37.1,0,0,0,3.2-2.587,9.166,9.166,0,0,0,1.893-2.329A5.312,5.312,0,0,0,32.373-13a4.85,4.85,0,0,0-.64-2.542A2.325,2.325,0,0,0,29.564-16.6a4.834,4.834,0,0,0-1.76.338,8.59,8.59,0,0,0-1.68.88,18.738,18.738,0,0,0-1.547,1.156q-.738.613-1.4,1.182h-.569l-.676-3.307q.587-.338,1.707-.871a17.013,17.013,0,0,1,2.6-.96,11.175,11.175,0,0,1,3.1-.427,12.339,12.339,0,0,1,3.7.533A6.088,6.088,0,0,1,35.8-16.409a4.229,4.229,0,0,1,1.04,2.969,6.107,6.107,0,0,1-.782,3.147,8.185,8.185,0,0,1-2.231,2.409,26.909,26.909,0,0,1-3.449,2.133q-2,1.058-4.453,2.338h.142l2.276-.036h7a1.255,1.255,0,0,0,.907-.293,1.631,1.631,0,0,0,.427-.684l.64-1.92H38.4L38.116,0ZM40.356-.942l1.813-.533a1.228,1.228,0,0,0,.578-.356.925.925,0,0,0,.222-.64V-22.809a1.273,1.273,0,0,0-.249-.791,1.681,1.681,0,0,0-.836-.524l-1.636-.551v-.711l6.773-1.476V-14.7a8.845,8.845,0,0,1,1.911-1.973,5.24,5.24,0,0,1,1.787-.844,7.678,7.678,0,0,1,1.76-.2,6.17,6.17,0,0,1,2.782.622,4.619,4.619,0,0,1,2,1.973,7.249,7.249,0,0,1,.747,3.52V-2.56a1.048,1.048,0,0,0,.231.711,1.228,1.228,0,0,0,.569.373l1.6.533V0h-9V-.942l1.76-.533a1.045,1.045,0,0,0,.542-.364,1.112,1.112,0,0,0,.222-.72v-7.627a13.554,13.554,0,0,0-.231-2.711,2.85,2.85,0,0,0-.951-1.7,3.3,3.3,0,0,0-2.124-.587,6.427,6.427,0,0,0-1.92.311,3.225,3.225,0,0,0-1.689,1.307V-2.489a.951.951,0,0,0,.222.658,1.228,1.228,0,0,0,.578.356l1.493.533V0h-8.96ZM69.031.356a6.044,6.044,0,0,1-2.773-.622A4.46,4.46,0,0,1,64.32-2.24a7.552,7.552,0,0,1-.711-3.52v-7.911a1.216,1.216,0,0,0-.267-.791,1.8,1.8,0,0,0-.836-.524l-1.529-.551v-.711l6.684-1.333v10.4A14.389,14.389,0,0,0,67.876-4.5a2.852,2.852,0,0,0,.9,1.689,3.182,3.182,0,0,0,2.107.587,5.111,5.111,0,0,0,2.231-.427A3.445,3.445,0,0,0,74.489-3.8v-9.867a.973.973,0,0,0-.258-.72,2.167,2.167,0,0,0-.827-.453L71.733-15.4v-.711l6.827-1.476V-3.609a1.305,1.305,0,0,0,.24.791,1.561,1.561,0,0,0,.862.507l1.636.48v.711L74.933.356H74.56V-2.667a7.6,7.6,0,0,1-2.267,2.24A6.141,6.141,0,0,1,69.031.356ZM91.271.48a21.494,21.494,0,0,1-3.4-.293A12.659,12.659,0,0,1,84.107-1.1V-22.809a1.266,1.266,0,0,0-.24-.782A1.768,1.768,0,0,0,83-24.124l-1.636-.551v-.711l6.791-1.476v12.124a6.935,6.935,0,0,1,1.991-2.018,5.8,5.8,0,0,1,1.947-.8,8.62,8.62,0,0,1,1.5-.169,5.975,5.975,0,0,1,3.609,1.084,6.952,6.952,0,0,1,2.3,2.987,11.092,11.092,0,0,1,.809,4.373,11.061,11.061,0,0,1-1.084,4.933,8.653,8.653,0,0,1-3.093,3.52A8.741,8.741,0,0,1,91.271.48Zm-.018-1.564A3.865,3.865,0,0,0,94-2.071a5.883,5.883,0,0,0,1.564-2.578,11.1,11.1,0,0,0,.507-3.387,13.06,13.06,0,0,0-.48-3.724,5.36,5.36,0,0,0-1.484-2.516,3.764,3.764,0,0,0-2.622-.907,6.664,6.664,0,0,0-1.7.267,2.756,2.756,0,0,0-1.627,1.3V-2.542a3.428,3.428,0,0,0,.8.658,6.162,6.162,0,0,0,1.156.569A3.3,3.3,0,0,0,91.253-1.084Z"
          transform="translate(8.27 32.86)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export function LogoSvgNY() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="122"
      height="46"
      viewBox="0 0 122 46"
    >
      <defs>
        <filter
          id="Контур_2"
          x="0.658"
          y="5.502"
          width="38.16"
          height="42.498"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" in="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feFlood floodOpacity="0.541" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="L2hub"
          x="0"
          y="0"
          width="122"
          height="58"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" in="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur-2" />
          <feFlood floodOpacity="0.541" />
          <feComposite operator="in" in2="blur-2" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="Эллипс_3"
          x="13"
          y="3"
          width="24"
          height="24"
          filterUnits="userSpaceOnUse"
        >
          <feOffset in="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur-3" />
          <feFlood floodColor="red" floodOpacity="0.62" />
          <feComposite operator="in" in2="blur-3" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="Эллипс_4"
          x="36"
          y="2"
          width="24"
          height="24"
          filterUnits="userSpaceOnUse"
        >
          <feOffset in="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur-4" />
          <feFlood floodColor="#f700ff" />
          <feComposite operator="in" in2="blur-4" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="Эллипс_5"
          x="25"
          y="4"
          width="23"
          height="23"
          filterUnits="userSpaceOnUse"
        >
          <feOffset in="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur-5" />
          <feFlood floodColor="#f7ff00" />
          <feComposite operator="in" in2="blur-5" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="Эллипс_6"
          x="52"
          y="2"
          width="24"
          height="24"
          filterUnits="userSpaceOnUse"
        >
          <feOffset in="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur-6" />
          <feFlood floodColor="#00fff7" />
          <feComposite operator="in" in2="blur-6" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="Эллипс_7"
          x="79"
          y="3"
          width="23"
          height="23"
          filterUnits="userSpaceOnUse"
        >
          <feOffset in="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur-7" />
          <feFlood floodColor="#fa0" />
          <feComposite operator="in" in2="blur-7" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="Эллипс_8"
          x="63"
          y="4"
          width="23"
          height="23"
          filterUnits="userSpaceOnUse"
        >
          <feOffset in="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur-8" />
          <feFlood floodColor="red" />
          <feComposite operator="in" in2="blur-8" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="Эллипс_9"
          x="70"
          y="3"
          width="23"
          height="23"
          filterUnits="userSpaceOnUse"
        >
          <feOffset in="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur-9" />
          <feFlood floodColor="#0f3" />
          <feComposite operator="in" in2="blur-9" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g
        id="Сгруппировать_45"
        data-name="Сгруппировать 45"
        transform="translate(-42 -24)"
      >
        <g transform="matrix(1, 0, 0, 1, 42, 24)" filter="url(#L2hub)">
          <text
            id="L2hub-2"
            data-name="L2hub"
            transform="translate(9 36)"
            fill="#fff"
            fontSize="40"
            fontFamily="Sitka Banner"
            fontWeight="700"
          >
            <tspan x="0" y="0">
              L2hub
            </tspan>
          </text>
        </g>
        <path
          id="Контур_3"
          data-name="Контур 3"
          d="M60.916,36S72.1,45.055,94.16,35.443c29.586,7.523,44.266,0,44.266,0"
          fill="none"
          stroke="#000"
          strokeWidth="1"
        />
        <g transform="matrix(1, 0, 0, 1, 42, 24)" filter="url(#Эллипс_3)">
          <g
            id="Эллипс_3-2"
            data-name="Эллипс 3"
            transform="translate(22 12)"
            fill="red"
            stroke="#000"
            strokeWidth="1"
          >
            <circle cx="3" cy="3" r="3" stroke="none" />
            <circle cx="3" cy="3" r="2.5" fill="none" />
          </g>
        </g>
        <g transform="matrix(1, 0, 0, 1, 42, 24)" filter="url(#Эллипс_4)">
          <g
            id="Эллипс_4-2"
            data-name="Эллипс 4"
            transform="translate(45 11)"
            fill="#f0c"
            stroke="#000"
            strokeWidth="1"
          >
            <circle cx="3" cy="3" r="3" stroke="none" />
            <circle cx="3" cy="3" r="2.5" fill="none" />
          </g>
        </g>
        <g transform="matrix(1, 0, 0, 1, 42, 24)" filter="url(#Эллипс_5)">
          <g
            id="Эллипс_5-2"
            data-name="Эллипс 5"
            transform="translate(34 13)"
            fill="#fe0"
            stroke="#000"
            strokeWidth="1"
          >
            <circle cx="2.5" cy="2.5" r="2.5" stroke="none" />
            <circle cx="2.5" cy="2.5" r="2" fill="none" />
          </g>
        </g>
        <g transform="matrix(1, 0, 0, 1, 42, 24)" filter="url(#Эллипс_6)">
          <g
            id="Эллипс_6-2"
            data-name="Эллипс 6"
            transform="translate(61 11)"
            fill="#00edff"
            stroke="#000"
            strokeWidth="1"
          >
            <circle cx="3" cy="3" r="3" stroke="none" />
            <circle cx="3" cy="3" r="2.5" fill="none" />
          </g>
        </g>
        <g transform="matrix(1, 0, 0, 1, 42, 24)" filter="url(#Эллипс_7)">
          <g
            id="Эллипс_7-2"
            data-name="Эллипс 7"
            transform="translate(88 12)"
            fill="#f80"
            stroke="#000"
            strokeWidth="1"
          >
            <circle cx="2.5" cy="2.5" r="2.5" stroke="none" />
            <circle cx="2.5" cy="2.5" r="2" fill="none" />
          </g>
        </g>
        <g transform="matrix(1, 0, 0, 1, 42, 24)" filter="url(#Эллипс_8)">
          <g
            id="Эллипс_8-2"
            data-name="Эллипс 8"
            transform="translate(72 13)"
            fill="red"
            stroke="#000"
            strokeWidth="1"
          >
            <circle cx="2.5" cy="2.5" r="2.5" stroke="none" />
            <circle cx="2.5" cy="2.5" r="2" fill="none" />
          </g>
        </g>
        <g transform="matrix(1, 0, 0, 1, 42, 24)" filter="url(#Эллипс_9)">
          <g
            id="Эллипс_9-2"
            data-name="Эллипс 9"
            transform="translate(79 12)"
            fill="#0f2"
            stroke="#000"
            strokeWidth="1"
            opacity="0.6"
          >
            <circle cx="2.5" cy="2.5" r="2.5" stroke="none" />
            <circle cx="2.5" cy="2.5" r="2" fill="none" />
          </g>
        </g>
      </g>
    </svg>
  );
}
